import { useEffect, useState } from 'react';

/**
 * 判断一个标题能否作为改稿对象：最低一级章节、非保护章节（参考文献）、且有 detailId
 */
export const isRewritableHeading = (attrs) =>
    !!attrs && !!attrs.isLowestChapter && !attrs.isProtected && !!attrs.detailId;

/**
 * 从编辑器文档里提取大纲
 * @returns {Array<{ id, text, level, pos, blockId, detailId, isLowestChapter, isProtected, rewritable }>}
 */
export function useOutline(editor) {
    const [outline, setOutline] = useState([]);

    useEffect(() => {
        if (!editor) return undefined;

        const updateOutline = () => {
            const headings = [];
            editor.state.doc.descendants((node, pos) => {
                if (node.type.name !== 'heading') return true;
                const text = node.textContent.trim();
                if (!text) return false;
                const { attrs } = node;
                headings.push({
                    id: attrs.blockId || `heading-${pos}`,
                    text,
                    level: attrs.level || 1,
                    pos,
                    blockId: attrs.blockId,
                    detailId: attrs.detailId,
                    isLowestChapter: !!attrs.isLowestChapter,
                    isProtected: !!attrs.isProtected,
                    rewritable: isRewritableHeading(attrs),
                });
                return false;
            });
            setOutline(headings);
        };

        updateOutline();
        editor.on('update', updateOutline);
        return () => {
            editor.off('update', updateOutline);
        };
    }, [editor]);

    return outline;
}
